import gql from 'graphql-tag';
import { Mutation } from 'core/index';

export const CONTENT_FIELDS = gql`
  fragment contentFields on Content {
    id
    slug
    type
    whitelabel
    isLiked
    likesCount
    isFollowed
    followersCount
    creator {
      id
      username
    }
    inSpace {
      id
    }
    pageViews
  }
`;

export const FOLLOW_MUTATION = gql`
  ${CONTENT_FIELDS}
  mutation Follow($followInput: FollowInput) {
    follow(followData: $followInput) {
      content {
        ...contentFields
      }
    }
  }
`;
export class FollowMutation extends Mutation {
  static conf = {
    GQL: FOLLOW_MUTATION,
    inputName: 'followInput',
    resultPath: 'follow.content',
  };
}

export const LIKE_MUTATION = gql`
  ${CONTENT_FIELDS}
  mutation Like($likeInput: LikeInput) {
    like(likeData: $likeInput) {
      content {
        ...contentFields
      }
    }
  }
`;
export class LikeMutation extends Mutation {
  static conf = {
    GQL: LIKE_MUTATION,
    inputName: 'likeInput',
    resultPath: 'like.content',
  };
}
